<svelte:options runes={true} />

<script lang="ts">
	interface Props {
		handleSignIn: () => void;
	}

	let { handleSignIn }: Props = $props();
</script>

<button
	onclick={handleSignIn}
	class="group w-full rounded-2xl border-2 border-white/40 bg-[rgb(75,115,200)] px-8 py-5
	font-semibold text-white transition-all duration-200 hover:border-white/60
	hover:bg-[rgb(65,105,190)] hover:shadow-lg hover:shadow-[rgb(75,115,200)]/25 focus:outline-none
	focus:ring-2 focus:ring-[rgb(75,115,200)]/50 focus:ring-offset-2 focus:ring-offset-transparent
	active:scale-[0.98]"
	style="background: linear-gradient(135deg, rgb(75,115,200) 0%,
	rgb(85,125,210) 100%);"
>
	<span class="flex translate-x-3 items-center justify-center">
		<span class="inline-block text-lg">Sign in</span>
		<svg
			class="ml-3 h-5 w-5 opacity-0 transition-all duration-200 group-hover:translate-x-1 group-hover:opacity-100"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M13 7l5 5m0 0l-5 5m5-5H6"
			></path>
		</svg>
	</span>
</button>
